import * as React from "react";

import theme from "@ui/themes/default";

import { style, Icon } from "./Symbolicons";

export const Cabinet = (props: Icon): React.ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 40 40"
    style={{ ...style(props.size, props.height), ...props.style }}
  >
    <path
      fill={props.color || theme.palette.grey600}
      d="M38.333 0H1.667C.75 0 0 .75 0 1.667c0 .916.75 1.666 1.667 1.666h36.666c.917 0 1.667-.75 1.667-1.666C40 .75 39.25 0 38.333 0zM1.667 38.333a1.667 1.667 0 003.333 0v-1.666h13.333v-30H1.667v31.666zM13.333 20a1.667 1.667 0 110 3.335 1.667 1.667 0 010-3.335zm8.334 16.667H35v1.666a1.667 1.667 0 003.333 0V6.667H21.667v30zm5-16.667a1.667 1.667 0 11-.002 3.335A1.667 1.667 0 0126.667 20z"
    ></path>
  </svg>
);
